import { connect } from 'react-redux'
import React, { Component } from 'react'
import { createAction } from 'redux-actions'
import VideoItem from './videoItem/VideoItem'
import { Modal, ModalFooter, ModalBody } from '../../misc/modals/modals'
import VideoListHeader from './VideoListHeader'
import { browserHistory, Link } from 'react-router'
import VideoCreator from './VideoCreator'
import Pagination from '../../misc/Pagination'
import { fetchVideos, SELECT, DESELECT, DESELECT_ALL, ZOOM, NOTIFY, EDIT_USER  } from '../../actions'
import { processUploadedFiles } from '../../misc/utilities'
import './videoList.css'
import { isMobile, isIOs, getVideosAndPending, getAllVideos } from '../../misc/selectors'
import AnimatedLogo from '../../assets/logo.gif'
import debounce from 'lodash/debounce'
import ZoomOverlay from './ZoomOverlay'
import { Helmet } from "react-helmet";
import MdVideoLibrary from 'react-icons/lib/md/video-library'
import BlueCheckmark from "../../assets/blue-checkmark.png"
import { setCookie } from '../../misc/utilities'
import Cookies from 'js-cookie'
import { Beforeunload } from 'react-beforeunload';

const mapStateToProps = (state, ownProps) => {
  const { videos, me, app } = state
  const { query } = ownProps

  return {
    query,
    me,
    app,
    isIOs: isIOs(state),
    pro: me.pro,
    selected: me.selected,
    pages: Math.ceil(videos.total / videos.count),
    // don't return uploads on albums because we don't know which album they're in
    items: getVideosAndPending(state),
    isFetching: videos.isFetching,
    isMobile: isMobile(state),
    activeUploads: getAllVideos(state).filter((v => !v.status))
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  select: (shortcode) => {
    dispatch(createAction(SELECT)(shortcode))
  },
  deselect: (shortcode) => {
    dispatch(createAction(DESELECT)(shortcode))
  },
  deselectAll: (shortcode) => {
    dispatch(createAction(DESELECT_ALL)(shortcode))
  },
  closeZoom: () => {
    dispatch(createAction(ZOOM)())
  },
  closeNotification: () => {
    dispatch(createAction(NOTIFY)({message: null, upgrade: null, error: null, dismissId: null, info: false}))
  }
})

class VideosList extends Component {
  constructor() {
    super()
    this.state = {
      playerMuted: true,
      currentSearch: null,
      canShowWelcome: false,
    }

    this.dispatchFetch = this.dispatchFetch.bind(this)
    this.dispatchFetchDebounced = debounce(this.dispatchFetch, 500, { leading: true, trailing: true })
  }

  dispatchFetch(options, force) {
    this.setState({ currentSearch: options.search })
    this.props.dispatch(fetchVideos(options, force))
  }

  getQueryArgs() {
    const { query } = this.props
    return {
      sort: query.sort || 'date_added',
      sortd: query.sortd || 'DESC',
      search: query.search,
      page: parseInt(query.page || 1),
    }
  }

  createQueryArgs(options) {
    const newQuery = {...this.props.query, ...(options || {})}
    const searchParams = new URLSearchParams(window.location.search);
    for (let q of Object.keys(newQuery)) {
      if (!newQuery[q]) {
        searchParams.delete(q)
      } else {
        searchParams.set(q, newQuery[q])
      }
    }
    return searchParams
  }

  fetch(options = {}, force = false, debounced = false) {
    browserHistory.replace('?' + this.createQueryArgs(options).toString())
    
    const processedOptions = {
      count: 12,
      ...this.getQueryArgs(),
      ...options,
    }

    this.setState(options)
    if (debounced) {
      this.dispatchFetchDebounced(processedOptions, force)
    } else {
      this.dispatchFetch(processedOptions, force)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.me.reloadVideos) {
      this.fetch({}, true);
      this.props.dispatch(createAction(EDIT_USER)({reloadVideos: false}))
    }
  }

  componentDidMount() {
    this.fetch()

    setTimeout(() => {
      this.setState({ canShowWelcome: true })
    }, 500)
  }

  componentWillUnmount() {
    clearInterval(this.refreshInterval)
  }

  isSelected(video) {
    return this.props.selected.contains(video.shortcode)
  }

  render() {
    const { me, query, app, dispatch, activeUploads, selected } = this.props
    return (
      <Beforeunload onBeforeunload={event => {
        if (activeUploads.length) {
          event.preventDefault();
        } 
      }}>
        <Helmet>
          <title>Dashboard - Streamable</title>
          <meta name="description" content="Upload, edit, and manage your video library."></meta>
          <link rel="canonical" href="https://streamable.com/videos" />
        </Helmet>
        <div className="videos-list">
          {query.error ?
            <div className="alert alert-danger">
              {query.error}
              <span onClick={() => browserHistory.replace('?' + this.createQueryArgs({error: null}).toString())} style={{'float': 'right', cursor: 'pointer'}}>Hide</span>
            </div>
          : ''}
          {query.alert ?
            query.alert == 'verified' ?
              <div className="alert alert-info">
                Your email has been verified. 
                <span onClick={() => browserHistory.replace('?' + this.createQueryArgs({alert: null}).toString())} style={{'float': 'right', cursor: 'pointer'}}>Hide</span>
              </div>
            :
              <div className="alert alert-info">
                {query.alert == 'downgrade' ? 'Downgrade successful. ' : query.alert == 'upgrade' ? 'Upgrade successful. ' : query.alert == 'already-subscribed' ? 'You are already subscribed. ' : ''}You're now on the <Link to="/settings">{me.plan_name}</Link> plan. 
                <span onClick={() => browserHistory.replace('?' + this.createQueryArgs({alert: null}).toString())} style={{'float': 'right', cursor: 'pointer'}}>Hide</span>
              </div>
          : ''}
          {me.stale && !Cookies.get('hideStaleNotification') ?
            <div className="alert alert-danger">
              You have {me.stale} video{me.stale > 1 ? 's' : ''} that will be deleted soon. 
              <span 
                style={{"marginLeft": '5px', cursor: 'pointer'}}
                onClick={(e) => {
                  browserHistory.push(`/upgrade?src_internal=dashboard-stale-notification${me.user_name ? '' : '-anon'}`)
                  e.preventDefault();
                }}>
                  Upgrade Now
              </span> 
              <span 
                onClick={(e) => {
                  setCookie('hideStaleNotification', 'true', 90000); 
                  this.setState({ hideStaleNotification: true })
                  e.preventDefault();
                }} 
                style={{float: 'right', cursor: 'pointer'}}>
                  Dismiss
              </span>
            </div>
          : ''}
          {app.message && (!app.dismissId || !Cookies.get('hideNotification-' + app.dismissId)) ?
            <div className={`alert alert-${app.info ? 'info' : 'warning'}`}>
              {app.message}
              {app.upgrade ?
                <a 
                  href={`/upgrade?src_internal=${app.message.replace(' ', '-')}`}
                  style={{"marginLeft": '5px'}}
                >
                    Upgrade Now
                </a> 
              : ''}
              <a 
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  this.props.closeNotification();
                  if (app.dismissId) {
                    setCookie('hideNotification-' + app.dismissId, 'true', 90000); 
                  }
                }} 
                style={{float: 'right'}}>
                  Dismiss
              </a>
            </div>
          : ''}
          {this.props.selected.size == 0 ?
          <VideoCreator />
          : ''}
          <VideoListHeader
            onChange={() => this.fetch({}, true)}
            onSearchChanged={(search) => {
              this.fetch({ search, page: 1 }, false, true)
            }}
            onSortChanged={(sort, sortd) => {
              this.fetch({ sort, sortd })
            }}
            {...this.props}
            {...this.getQueryArgs()}
          />
          <div
            className={
              `grid row videos-list-items ${this.props.items.length ? '' : 'empty'}`
            }
          >
            {this.props.items.map((video, i) => (
              <VideoItem
                me={this.props.me}
                key={video.shortcode || video.local_id}
                selectableKey={video.shortcode || video.local_id}
                type='grid'
                video={video}
                selected={this.isSelected(video)}
                onSelect={() => {
                  this.props.select(video.shortcode || video.local_id)
                }}
                onDeselect={() => {
                  this.props.deselect(video.shortcode || video.local_id)
                }}
                isMobile={isMobile}
                showWelcome={video.new_upload && this.props.items.length == 1 && this.props.me.first_run}
              />
            ))}
          </div>
          {this.props.isFetching === false && !this.props.items.length && this.state.currentSearch === this.getQueryArgs().search
            ? this.state.currentSearch
                ?
                  <div className="video-list-placeholder" style={{marginTop:'50px'}}>No videos match your search</div>
                :
                  this.state.canShowWelcome ?
                    <div className="row video-list-placeholder-container">
                      <div className="video-list-placeholder">
                        <form
                          ref={r => {
                            if (r) {
                              this.formRef = r
                            }
                          }}
                          style={{ display: 'none' }}
                        >
                          <input
                            key="fileInput"
                            type="file"
                            multiple={false}
                            ref="fileInput"
                            onChange={() => {
                              const files = this.refs.fileInput.files
                              if (!files.length) {
                                return
                              }
                              processUploadedFiles(dispatch, files, null, me.plan_max_length, me.plan_max_size)
                              .then(() => {
                                this.formRef.reset()
                              })
                            }}
                          />
                        </form>
                        
                        <div className="embed-container" onClick={(e) => {
                          e.preventDefault()
                          this.refs.fileInput.click()
                        }}>
                          <div className="placeholder-emphasis" style={{fontSize: '50px', marginBottom: '10px'}}><MdVideoLibrary /></div>
                          <div className="placeholder-emphasis">Select videos to upload.</div>
                          <div style={{color: '#666', fontSize:'14px', marginBottom: '20px'}}>or drag and drop your videos here.</div>
                        </div>
                      </div>
                    </div>
                : ''
            : ''}
          {this.props.pages > 1
            ? <div className="col-12">
              <Pagination
                page={this.getQueryArgs().page}
                pages={this.props.pages}
                onChange={(page) => {
                  this.fetch({ page })
                }}
              />
            </div>
            : ''}
          {this.props.isFetching === true || (this.state.currentSearch || '') !== (this.getQueryArgs().search || '')
            ? <div className="loading-indicator">
              <img src={AnimatedLogo} alt="presentation" />
            </div>
            : ''}
          {this.props.me.zoomed
            ? 
              <ZoomOverlay
                me={this.props.me}
                video={this.props.me.zoomed}
                onClose={this.props.closeZoom}
                isMobile={this.props.isMobile}
              />
            : ''}
        </div>
      </Beforeunload>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VideosList)
